"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeEditorWindow = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const AdaptableContext_1 = require("../AdaptableContext");
const ThemePopup_1 = require("./ThemePopup");
const ThemeEditorWindow = () => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const moduleInfo = adaptable.ModuleService.getModuleInfoByModule('Theme');
    return (React.createElement(rebass_1.Box, { p: 2 },
        React.createElement(ThemePopup_1.ThemePopup, { hideShowInWindow: true, moduleInfo: moduleInfo, api: adaptable.api })));
};
exports.ThemeEditorWindow = ThemeEditorWindow;
